/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
import { useRouter } from "next/router"
import { useRef, useState } from "react"
import { SwiperSlide } from "swiper/react"
import { Cover } from "@components/anti/Cover"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import { translations } from "src/helper/translations"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import SwiperNavigation from "../SwiperNavigation"

export default function SectionFullSlider({ sectionName, data, imgHeight }) {
  const [trigger, anim] = useScrollAnim()
  const [swipePage, setSwipePage] = useState(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  const router = useRouter()

  return (
    <section className={`sc-full-slider ${sectionName}`} ref={trigger}>
      <SliderSwiper
        swiperRef={swiperRef}
        slidesPerView={1}
        breakpoints={null}
        spaceBetween={0}
        // autoplay={
        //   data?.length > 1
        //     ? {
        //         delay: 2500,
        //         disableOnInteraction: false,
        //       }
        //     : false
        // }
        onSwiper={setSwipePage}
        onSlideChange={(slide) => {
          setCurrentSlide(slide?.realIndex)
        }}
        loop={data?.length > 1}
      >
        {data?.map((item, i) => (
          <SwiperSlide key={`${sectionName}-${i}`}>
            <Cover
              img={item.img}
              imgMd={item.imgMd}
              imgHeight={imgHeight ?? "h-500px h-md-600px"}
              contentMaxWidth="mw-md-700px"
              label={item.label}
              title={item.title}
              text={item.text}
              imgOverlay={item.imgOverlay}
            >
              {item.link ? (
                <div
                  onClick={() => router.push(item.link)}
                  className="link-cover text-white text-capitalize"
                  role="button"
                  tabIndex={0}
                >
                  {item.linkText ?? translations[`learn_more_${router.locale}`]}{" "}
                  <span className="air ai-arrow-right" />
                </div>
              ) : null}
            </Cover>
          </SwiperSlide>
        ))}
        {data?.length > 1 ? (
          <div className="container container-footer">
            <div className="wrapper-pagination">
              <div className="pagination-swiper-list">
                {data?.map((_, i) => (
                  <div
                    className={`pagination-swiper-item ${
                      i === currentSlide ? "pagination-swiper-item-active" : ""
                    }`}
                    key={`pagination-item-${i}`}
                    onClick={() => swipePage?.slideTo(i)}
                    role="button"
                    tabIndex={0}
                  />
                ))}
              </div>
            </div>
            <SwiperNavigation handleNext={handleNext} handlePrev={handlePrev} />
          </div>
        ) : null}
      </SliderSwiper>
    </section>
  )
}
